export const routes = [
  {
    path: '/home',
    name: 'home',
    alias: '/',
    hidden: true,
    component: () => import('@/views/pc/home/home.vue'),
    meta: {
      title: 'home',
      scrollToTop: true,
    },
  },
  {
    path: '/swap',
    name: 'swap',
    hidden: true,
    component: () => import('@/views/pc/trade/trade.vue'),
    meta: {
      title: 'swap',
      scrollToTop: true,
    },
  },
  // {
  //   path: '/win',
  //   name: 'win',
  //   hidden: true,
  //   component: () => import('@/views/pc/win/win.vue'),
  //   meta: {
  //     title: 'win',
  //     scrollToTop: true,
  //   },
  // },
  {
    path: '/liquidity',
    name: 'liquidity',
    hidden: true,
    component: () => import('@/views/pc/earn/earn.vue'),
    meta: {
      title: 'liquidity',
      scrollToTop: true,
    },
  },
]